import React, { Component } from 'react';
import { connect } from 'react-redux';
import ForgotPasswordConfirm from '../../components/ForgotPassword/ForgotPasswordConfirm';
import LoginClass from '../../shared/loginClass/LoginClass';
import { forgotPasswordConfirm } from '../../store/actions/userActions';
import { ToastContainer, toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';

class ForgotPasswordConfirmContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggingOut: false,
        };

        this.cognitoAuth = new LoginClass();
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.forgotPasswordConfirmStatus && nextProps.forgotPasswordConfirmStatus.status !== 200) {
        toast.error(nextProps.forgotPasswordConfirmStatus.message);
        return;
      }
      if (nextProps.forgotPasswordConfirmStatus && nextProps.forgotPasswordConfirmStatus.status === 200) {
        toast.success(nextProps.forgotPasswordConfirmStatus.message);
        setTimeout(() => window.location.replace(window.location.origin), 5000);
        return;
      }
    }

    onForgotPasswordConfirm = (data) => {
      this.props.dispatch(forgotPasswordConfirm(data));
    }

    render() {
      const slitedData = this.props.location.search.split('=');
      const locationEmail = decodeURIComponent(slitedData[1]).split('&')[0];
      return (
        <div>
          <ToastContainer
            position="top-right"
            type="success"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
          />
          <ForgotPasswordConfirm
            forgotPassConfirmStatus = {this.props.forgotPasswordConfirmStatus}
            onForgotPasswordConfirm = {this.onForgotPasswordConfirm}
            forgotPasswordPending = {this.props.forgotPasswordPending}
            locationCode = {slitedData[2]}
            locationEmail = {locationEmail}
          />
        </div>
      )
    }
}


function MapStateToProps(state) {
  return {
    forgotPasswordPending: state.user.forgotPasswordPending,
    forgotPassStatus: state.user.forgotPassword,
    forgotPasswordConfirmStatus: state.user.forgotPasswordVerify,
  };
}

export default withRouter(connect(MapStateToProps)(ForgotPasswordConfirmContainer));



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/ForgotPasswordConfirmContainer.js